<template>
  <div class="page" :key="this.updateKey">
      <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'Page',
  data:function(){
    return {
      updateKey:0,
    }
  },
  methods:{
    forceUpdate(){
      this.updateKey=new Date().getTime();
    }
    
  },
  created(){
    this.animate=false
  },
  mounted(){
    
    //window.addEventListener('keyboardDidHide',this.forceUpdate);
  },
  beforeDestroy(){
    //window.removeEventListener('keyboardDidHide', this.forceUpdate);
  }
  
  
}




</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page{
  display:flex;
  flex-direction: column;
  width:100%;
  height:100%;
  /*
  width:100vw;
  height:100vh;
  */
  overflow:hidden;
}




</style>
